import { ArticleDataInterface, ArticleSectionDataInterface } from './newsroom-overview.types'

export const getCachedArticles = (): ArticleDataInterface[] => {
    const articles = sessionStorage.getItem('cachedArticles')

    if (! articles) return []

    return JSON.parse(articles)
}
export const getCachedSections = (): ArticleSectionDataInterface[] => {
    // TODO: AAL-554 disable getting sections until newsroom phase 2 has been finished (24-07-2023)

    return []
}

export const setCachedArticles = (
    data: ArticleDataInterface[],
) => sessionStorage.setItem('cachedArticles', JSON.stringify(data))

export const setCachedSections = (
    data: ArticleSectionDataInterface[],
) => sessionStorage.setItem('cachedSections', JSON.stringify(data))
